import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "25", "height": "25", "viewBox": "0 0 25 25", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M5.73859 13.7305V19.7305", "stroke": "#27C39F", "stroke-width": "3" } }), _c("path", { attrs: { "d": "M12.0786 9.73047V19.7305", "stroke": "#27C39F", "stroke-width": "3" } }), _c("path", { attrs: { "d": "M18.4086 4.73047V19.7305", "stroke": "#27C39F", "stroke-width": "3" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NetworkStabilityIcon = __component__.exports;
export {
  NetworkStabilityIcon as default
};
